module.exports = __webpack_public_path__ + "img/qb_icon.fcd8fbe0.png";